module.exports = __webpack_public_path__ + "static/media/card-elgeemedeerei.108460cf.png";